<div class='select-reference-signature-container'>
  <form *ngIf='signatureSelectForm' [formGroup]='signatureSelectForm' (ngSubmit)='onSubmit()'>
    <app-field-label-container
      [displayTooltip]='false'
      fieldLabel='Brands'
      labelFor='referenceSignatureSelected'
    />
    <div class='select-reference-signature-select-field-container'>
      <mat-form-field appearance='outline'>
        <mat-select formControlName='referenceSignatureSelected' required placeholder='Select a brand'>
          <mat-optgroup
            *ngFor='let referenceSignature of referenceSignatureList$ | async'
            [class.hide-label]='referenceSignature.appServiceList.length === 0'
          >
            <ng-container *ngIf='referenceSignature.appServiceList.length === 0'>
              <mat-option [value]='"signature_" + referenceSignature.id' [class.brand-option-solo-option]='true'>
                <span class='s-regular dsp-color-text-neutral'>{{ referenceSignature.name }}</span>
              </mat-option>
            </ng-container>

            <span
              *ngIf='referenceSignature.appServiceList.length !== 0'
              class='s-regular dsp-color-text-neutral'>
              {{ referenceSignature.name }}
            </span>
            <ng-container *ngIf='referenceSignature.appServiceList.length !== 0'>
              <mat-option
                *ngFor='let appService of referenceSignature.appServiceList'
                [value]='"signature_" + appService.signatureId + "_appService_" + appService.id'
                [class.brand-option-solo-option]='false'
              >
                <span class='xs-regular dsp-color-text-quiet'>{{ appService.name }}</span>
              </mat-option>
            </ng-container>
          </mat-optgroup>
        </mat-select>
        <mat-error
          *ngIf="signatureSelectForm.get('referenceSignatureSelected')!.invalid && signatureSelectForm.get('referenceSignatureSelected')!.touched"
          i18n>
          The brand selection is mandatory
        </mat-error>
      </mat-form-field>
      <app-dsp-button
        [disabled]='!signatureSelectForm.valid || (referenceSignatureList$ | async)?.length === 0'
        label='Validate'
        size='large'
        type='primary'
      />
    </div>
  </form>
</div>
